export default __webpack_public_path__ + "static/media/jr.b40266dd.jpeg";